import React from 'react';
import { QRCode, Space } from 'antd';

export default function DeliveryQrcode({
  link,
  code,
}: {
  link: string;
  code: string;
}) {
  return (
    <div className="flex flex-col w-full justify-center gap-2 text-center">
      <div className="w-ful">
        <Space direction="vertical" align="end">
          <QRCode
            value={link}
            bordered={false}
            size={100}
            style={{ textAlign: 'center' }}
          />
        </Space>
      </div>
      <div>
        {code} | {link}
      </div>
    </div>
  );
}
